import * as React from "react";
import styled from "styled-components";

import Select, { Option } from "@ingka/select";
import FormField from "@ingka/form-field";
import Button from "@ingka/button";
import InlineMessage from "@ingka/inline-message";

import { MaintainerApplications } from "./RequestNewMarketAccess";
import SelectMarkets from "../SelectMarkets/SelectMarkets";

interface RequestNewMarketAccessLayoutProps {
	userApplications: MaintainerApplications[];
	onAppChange: ((...args: any[]) => any) | undefined;
	marketsDataLoading: boolean;
	selectedMarkets: string[];
	marketsData: { key: string; name: string }[];
	requestingMarketsLoading: boolean;
	setSelectedMarkets: (val: string[]) => void;
	onRequestMarkets: () => void;
	selectedApp?: string;
	appId?: string;
}

const ButtonWrapper = styled.div`
	margin-top: 2rem;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Layout: React.FC<RequestNewMarketAccessLayoutProps> = ({
	userApplications,
	selectedApp,
	onAppChange,
	marketsData,
	marketsDataLoading,
	selectedMarkets,
	setSelectedMarkets,
	onRequestMarkets,
	requestingMarketsLoading,
	appId,
}) => {
	return (
		<>
			{userApplications.length ? (
				<>
					{!appId && (
						<FormField>
							{userApplications?.length > 1 ? (
								<Select
									id={"request-market-applications"}
									label="Select Application"
									onChange={onAppChange}
									disabled={requestingMarketsLoading}
								>
									{userApplications?.map((app) => (
										<Option value={app.id} name={app.name} />
									))}
								</Select>
							) : (
								<>
									<p>You only have one application to request markets!</p>
									<h2>{userApplications[0].name}</h2>
								</>
							)}
						</FormField>
					)}

					<SelectMarkets
						id="new-market-access"
						label="Select markets"
						marketsData={marketsData}
						loading={marketsDataLoading}
						selected={selectedMarkets}
						onChange={setSelectedMarkets}
					/>

					<ButtonWrapper>
						<Button
							id="request-markets-access"
							text="Request Markets Access"
							type="emphasised"
							loading={requestingMarketsLoading}
							disabled={!selectedApp || !selectedMarkets.length}
							onClick={onRequestMarkets}
						/>
					</ButtonWrapper>
				</>
			) : (
				<InlineMessage
					title="No Applications to request markets"
					body="Seems like you are admin in all the applications"
				/>
			)}
		</>
	);
};

export default Layout;
